export const SET_FORM_STEP = "SET_FORM_STEP";

export const setFormStepData = data => ({
  type: SET_FORM_STEP,
  payload: { data },
});
